import {
    HttpInterceptorFn,
    HttpErrorResponse, HttpStatusCode
} from '@angular/common/http';

import { namedAuthRoutes } from '../auth/auth-routing.module';
import { SESSION_EXPIRED } from '@lib/auth/session-expired';
import { catchError, throwError } from 'rxjs';

let redirecting = false;

const sessionTimeoutInterceptor: HttpInterceptorFn = (req, next) => {
    if (typeof window === 'undefined') {
        return next(req);
    }

    // if pathname starts with any publicNamedRoutes, then we don't want to redirect to the login page on 401 errors
    const pathname = window.location.pathname;
    const base = namedAuthRoutes.base;
    const authRouteValues = Object.values(namedAuthRoutes.routes);

    const isOnAuthPublicRoute = authRouteValues.some(routePath => {
        // match both '/auth/login' and '/login' (in case there are routes registered at root too)
        return pathname.startsWith(`/${base}/${routePath}`) || pathname.startsWith(`/${routePath}`);
    });

    if (isOnAuthPublicRoute) {
        // We're on a public auth route, so don't do the redirect handling here — forward the request normally
        return next(req);
    }

    const isLogoutRequest = req.url.endsWith('/auth/logout');

    // Not on an auth public route — attach error handling to perform redirects on 401/XSRF
    return next(req).pipe(
        catchError((error: unknown) => {
            /* if we have an HttpErrorResponse
             * and we're not already redirecting */
            if (!(error instanceof HttpErrorResponse)) {
                return throwError(() => error);
            }
            switch (error.status) {
                case HttpStatusCode.Unauthorized:
                    if (!redirecting) {
                        redirecting = true;
                        window.location.href = namedAuthRoutes.base + '/' + namedAuthRoutes.routes.login;
                    }
                    break;
                case SESSION_EXPIRED:
                    /*
                     * Logging out is exempt: an expired session already is the outcome, so
                     * AuthenticationService.logout() completes normally and the caller navigates
                     * to the login page. Reloading here would race that navigation and leave the
                     * user apparently still signed in.
                     */
                    if (!isLogoutRequest) {
                        // reload to get a new XSRF token
                        window.location.reload();
                    }
                    break;
            }

            return throwError(() => error);
        })
    );
};
export default sessionTimeoutInterceptor;
